// SettingsSidebar.tsx
import { Settings } from "lucide-react";

export interface SettingsTab {
    id: string;
    label: string;
    icon: React.ReactNode;
}

export function SettingsSidebar({
    tabs,
    activeTab,
    onTabChange,
}: {
    tabs: SettingsTab[];
    activeTab: string;
    onTabChange: (tabId: string) => void;
}) {
    return (
        <div className="bg-gray-900 border-r border-gray-800 flex flex-col h-full w-54 shrink-0">
            {/* Header */}
            <div className="h-12 w-full shrink-0 border-b border-gray-800 flex items-center px-3 gap-3">
                <div className="bg-orange-600 p-1.5 rounded-lg border border-orange-500/30 shrink-0">
                    <Settings className="text-white h-4 w-4" />
                </div>
                <h1 className="text-sm font-bold text-white tracking-wide whitespace-nowrap">
                    Settings
                </h1>
            </div>

            {/* Tab List */}
            <div className="flex-1 overflow-y-auto custom-scroll p-1.5 space-y-1">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => onTabChange(tab.id)}
                        className={`w-full flex items-center gap-3 px-3 h-9 rounded-md transition-all duration-200 border ${activeTab === tab.id
                            ? "bg-orange-600 text-white shadow-sm border-orange-500/20"
                            : "text-gray-200 hover:text-gray-200 hover:bg-gray-800 border-transparent"
                            }`}
                    >
                        <span className="shrink-0 flex items-center justify-center w-5 h-5">
                            {tab.icon}
                        </span>
                        <span className="font-bold text-[11px] uppercase tracking-wider whitespace-nowrap">
                            {tab.label}
                        </span>
                    </button>
                ))}
            </div>
        </div>
    );
}
